import { render, staticRenderFns } from "./ProducerLogin.vue?vue&type=template&id=6ae6d196&scoped=true&"
import script from "./ProducerLogin.vue?vue&type=script&lang=js&"
export * from "./ProducerLogin.vue?vue&type=script&lang=js&"
import style0 from "./ProducerLogin.vue?vue&type=style&index=0&id=6ae6d196&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6d196",
  null
  
)

export default component.exports